import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { useAuth } from '@/hooks/useAuth';
import { usePhotos } from '@/hooks/usePhotos';
import { useUsers } from '@/hooks/useUsers';
import Layout from '@/pages/Layout';

function App() {
  const { user, loading: authLoading } = useAuth();
  const { photos, loading: photosLoading } = usePhotos();
  const { users, loading: usersLoading } = useUsers();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  console.log('user', user, 'authLoading', authLoading, 'pathname', pathname);

  useEffect(() => {
    if (!user && !authLoading) {
      // TODO confirm if this is right way to go
      navigate('/login');
    } else if (pathname === '/') { // this is prob not the right way to go
      navigate('/photos');
    }
  }, [user, authLoading, navigate, pathname]);

  useEffect(() => {
    if (!photosLoading && photos.length > 0) {
      console.log('Photos loaded:', photos);
    }
  }, [photos, photosLoading]);

  useEffect(() => {
    if (user) {
      console.log('User loaded:', user);
    }
  }, [user]);

  useEffect(() => {
    if (!usersLoading && users.length > 0) {
      console.log('Users loaded:', users);
    }
  }, [users, usersLoading]);

  return (
    <Layout>
      <div className="p-0 md:p-4 text-stone-500 min-h-[calc(100vh-6rem)]">
        {photosLoading ? (
          <div>Loading photos...</div>
        ) : (
          <>
            <Outlet />
          </>
        )}
      </div>
    </Layout>
  )
}

export default App;
